import React, { useState } from 'react'
import { freePlanMsg } from './Utils'
import { useEffect } from 'react'
import { Link } from 'react-router-dom'

function Freeaudit(props) {

  const [first, setfirst] = useState("")

  useEffect(() => {
    if (!props.planStatus.status) {
      setfirst(props.planStatus.message)
    }
  }, [props])


  return (
    <>
      {first && first ? <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "200px", border: "1px solid #ff601f", marginTop: "20px", marginBottom: "20px", padding: "20px" }} >
        <h3 style={{ color: "black" }}>
          <div dangerouslySetInnerHTML={{ __html: first }} />
        </h3>
      </div> : null}
    </>
  )
}

export default Freeaudit